import GSAP from 'gsap'

import Animation from 'classes/Animation'

export default class Text extends Animation {
  constructor ({ element, elements }) {
    super({
      element,
      elements
    })
    this.tl = GSAP.timeline({ delay: 0.5 })
  }

  animateIn () {
    this.tl.fromTo(this.element, {
      autoAlpha: 0
    }, {
      autoAlpha: 1,
      duration: 1.5,
      ease: 'expo.out',
      rotation: 0.01
    })
  }
}
